export default "__VITE_ASSET__CF2ND$PY__"